import wix from '../services/wix';
import { setCurrentChatroom } from './index';
import { expandWidget } from './expandCollapse';
import { AVATARS } from '../constants/avatars';
import { chatSdk } from '@wix/chat-sdk';

export const focusChannel = ({
  channelId,
  type,
  requestId,
}: {
  channelId: string;
  type: string;
  requestId: string;
}) => {
  return async function(dispatch, getState) {
    const responseEventName = `ChatWidget.focusChannelResponse.${requestId}`;
    if (!channelId && type !== 'Business') {
      console.error(
        '`chatroom` or `type` must be populated when focusing on channel',
      );
      return wix.publishToPubSub(responseEventName, { success: false });
    }

    try {
      const chatroomId =
        !channelId && type === 'Business'
          ? getState().businessChatRoomId
          : channelId;

      const room = await chatSdk.getChatroom({ chatroomId });
      const { name, otherParticipantId: userId } = room;
      const imgUrl = room.image && room.image.url;
      const avatar = imgUrl
        ? { ...AVATARS.IMG.prop, imgUrl }
        : AVATARS.NONE.prop;
      dispatch(setCurrentChatroom({ id: channelId, name, userId, avatar }));
      dispatch(expandWidget());
      wix.publishToPubSub(responseEventName, { success: true });
    } catch (e) {
      console.error('Catch an error in focusChannel Action,', e);
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
